import { FillLayer, LineLayer } from '@trimblemaps/trimblemaps-js';
import { FeatureTypes, MapLayers, MapSources } from '../enums';
import { isVisibleUtil } from '../mapUtils';

/**
 * Creates a layer to display polygons on the map for each 'featureType' of 'areaPolygon' in the given map source.
 * Adds the balance areas center layer to the map if it doesn't already exist
 * @param map Instance of your map
 * @param mapSource Name of the map source
 * @param isVisible Indicator if the map layer is visible
 */
export const addAreasPolygonFillLayer = ({
    map,
    mapSource,
    isVisible,
}: {
    map: TrimbleMaps.Map;
    mapSource: MapSources;
    isVisible: boolean;
}): void => {
    const visibility = isVisibleUtil(isVisible);

    const layer: FillLayer = {
        id: MapLayers.areaPolygonFillLayer,
        type: 'fill',
        source: mapSource,
        layout: {
            visibility,
        },
        paint: {
            'fill-color': ['get', 'color'],
            'fill-outline-color': ['get', 'outlineColor'],
            'fill-opacity': 0.5,
        },
        filter: ['all',
            ['==', 'featureType', FeatureTypes.AreaPolygon],
        ],
    };

    if (map.getLayer(MapLayers.areaPolygonFillLayer) === undefined) {
        map.addLayer(layer);
    }
};

/**
 * Creates a layer to display polygons on the map for each 'featureType' of 'areaPolygon' in the given map source.
 * Adds the balance areas center layer to the map if it doesn't already exist
 * @param map Instance of your map
 * @param mapSource Name of the map source
 * @param isVisible Indicator if the map layer is visible
 */
export const addAreasPolygonLineLayer = ({
    map,
    mapSource,
    isVisible,
}: {
    map: TrimbleMaps.Map;
    mapSource: MapSources;
    isVisible: boolean;
}): void => {
    const visibility = isVisibleUtil(isVisible);

    const layer: LineLayer = {
        id: MapLayers.areaPolygonLineLayer,
        type: 'line',
        source: mapSource,
        layout: {
            visibility,
        },
        paint: {
            'line-color': ['get', 'outlineColor'],
            'line-width': [
                'case',
                ['boolean', ['feature-state', 'hover'], false],
                2,
                1,
            ],
        },
        filter: ['all',
            ['==', 'featureType', FeatureTypes.AreaPolygon],
        ],
    };

    if (map.getLayer(MapLayers.areaPolygonLineLayer) === undefined) {
        map.addLayer(layer);
    }
};
